export interface MonthOption {
  value: number
  label: string
}

// Intl is used instead of moment's per-instance .locale() because it doesn't depend on
// moment locale-data files being registered on the same module instance that renders the
// labels (the "moment locale desync" failure mode already solved this way in
// PainterScheduleView/dateUtils.ts). Day is fixed at 1 so no month ever overflows into the
// next one the way moment().month(i) can on days 29-31.
export function getMonthOptions(lang: string): MonthOption[] {
  const formatter = new Intl.DateTimeFormat(lang, { month: 'long' })
  return Array.from({ length: 12 }, (_, i) => ({
    value: i,
    label: formatter.format(new Date(2000, i, 1))
  }))
}

// Always returns a valid option so callers can never dereference undefined, even if
// monthIndex is out of range (e.g. NaN from an invalid moment).
export function resolveMonthOption(monthOptions: MonthOption[], monthIndex: number): MonthOption {
  return monthOptions.find((option) => option.value === monthIndex) ?? monthOptions[0]
}
